import type { HighlightDataTexture } from "../HighlightDataTexture";
import { THREETextRenderer } from "../THREETextRenderer";
import { HatchMaterialFactory } from "./hatchMaterial";
import { LineBasicMaterialFactory } from "./LineBasicMaterialFactory";
import { LineStrokeMaterialFactory } from "./lineStrokeMaterial";
import { MeshBasicMaterialFactory } from "./MeshBasicMaterialFactory";

export function prepareMaterialsForRender(highlightDataTexture?: HighlightDataTexture) {
  THREETextRenderer.instance.prepareRender(highlightDataTexture);
  HatchMaterialFactory.instance.prepareRender(highlightDataTexture);
  LineStrokeMaterialFactory.instance.prepareRender(highlightDataTexture);
  LineBasicMaterialFactory.instance.prepareRender(highlightDataTexture);
  MeshBasicMaterialFactory.instance.prepareRender(highlightDataTexture);
}
